import { ColumnDef } from "@tanstack/react-table";
import { DashboardRankingsSpace } from "../../types";

interface DashboardRankingsSpacesColumnsProps<TData> {
  translations: Record<string, string>;
}

export function DashboardRankingsSpacesColumns({
  translations,
}: DashboardRankingsSpacesColumnsProps<DashboardRankingsSpace>): ColumnDef<DashboardRankingsSpace>[] {
  return [
    {
      accessorKey: "position",
      header: translations.position,
      cell: (info) => `${info.getValue()}º`,
      enableSorting: false,
    },
    {
      accessorKey: "name",
      header: translations.name,
      cell: (info) => info.getValue(),
      enableSorting: false,
    },
    {
      accessorKey: "value",
      header: translations.value,
      cell: (info) => info.getValue(),
      enableSorting: false,
    },
  ];
}
